import { createSearchParams } from "react-router";

import { useTabsStore } from "@user/store/tabs_store";

function navigateByPath(path: string, searchParams?: any) {
  const search = createSearchParams(searchParams as any).toString();
  useTabsStore.getState().addTab(path, search);
}

function reload() {
  const tab = useTabsStore.getState().getCurrTab()!;
  useTabsStore.getState().addTab(tab.path, tab.search);
}

function query(key: string) {
  const tab = useTabsStore.getState().getCurrTab()!;
  const currParams = new URLSearchParams(tab.search);
  return currParams.get(key) || "";
}

export default {
  navigateByPath,
  reload,
  query,
};
